export default {
  createLoading: false,
  soloBookRecord: null,
  soloBookRecordList: [],
  soloBookTotal: 0,
  soloBookFilteredCount: 0
}
